import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from 'react';
type AudioRtcPlayerProps = {
  url: string | null;
  ref?: any;
  autoPlay?: boolean;
};

const AudioRtcPlayer: React.FC<AudioRtcPlayerProps> = forwardRef(
  (props: AudioRtcPlayerProps, ref) => {
    const { url, autoPlay } = props;
    const audioPlayerRef = useRef<any>(null);
    const audioElementRef = useRef<HTMLVideoElement>(null);
    const playIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

    useEffect(() => {
      if (autoPlay && url) {
        handlePlay();
      }
    }, [autoPlay, url]);

    useEffect(() => {
      return () => {
        clearPlayInterval();
        handlePause();
      };
    }, []);

    useImperativeHandle(
      ref,
      () => ({
        handlePlay,
        handlePause,
      }),
      [url]
    );

    const clearPlayInterval = () => {
      if (playIntervalRef.current) {
        clearInterval(playIntervalRef.current);
        playIntervalRef.current = null;
      }
    };

    const handlePlay = () => {
      clearPlayInterval();
      if (audioPlayerRef.current) {
        audioPlayerRef.current?.close();
      }
      audioPlayerRef.current = new (window as any).SrsRtcPlayerAsync();

      const audioElement = document.getElementById(
        'audio-rtc-player'
      ) as HTMLVideoElement;
      if (
        audioElement &&
        audioPlayerRef.current &&
        audioPlayerRef.current.stream
      ) {
        audioElement.srcObject = audioPlayerRef.current.stream;
      }

      audioPlayerRef.current
        .play(url)
        .then(() => {})
        .catch(() => {});
      playIntervalRef.current = setInterval(() => {
        if (audioElementRef.current) {
          clearPlayInterval();
          audioElementRef.current!.play();
        }
      }, 10);
    };

    const handlePause = () => {
      clearPlayInterval();
      audioPlayerRef.current && audioPlayerRef.current.close();
      audioPlayerRef.current = null;
    };

    return (
      <video
        id="audio-rtc-player"
        ref={audioElementRef}
        autoPlay
        style={{
          position: 'absolute',
          visibility: 'hidden',
          bottom: 20,
          zIndex: -1,
        }}
      ></video>
    );
  }
);

AudioRtcPlayer.displayName = 'AudioRtcPlayer';

export default AudioRtcPlayer;
